/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Routes } from "@angular/router";

import { AuthComponent } from "./components/auth.component";
import { LoginComponent } from "./components/login/login.component";
import { LoginTokenComponent } from "./components/login-token/login_token.component";
import { RequestPasswordComponent } from "./components/request-password/request-password.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { LoginKeyComponent } from "./components";

export const AuthRoutes: Routes = [
  {
    path: "auth",
    component: AuthComponent,
    children: [
      {
        path: "",
        component: LoginComponent,
      },
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "acesso/:token",
        component: LoginTokenComponent,
      },
      {
        path: "request-password",
        component: RequestPasswordComponent,
      },
      {
        path: "reset-password",
        component: ResetPasswordComponent,
      },
      {
        path: ":invited",
        component: LoginComponent,
      },
      {
        path: "access-key/:key",
        component: LoginKeyComponent,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/auth/auth.routes.ts